import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=4fb277b6&scoped=true&"
import script from "./CustomAlert.vue?vue&type=script&lang=ts&"
export * from "./CustomAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb277b6",
  null
  
)

export default component.exports